import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { categories, HIDDEN_CATEGORIES } from "../mock";

export default function CategoryGrid() {
  const visible = categories.filter((c) => !HIDDEN_CATEGORIES.includes(c.slug));
  return (
    <section className="section-padding bg-muted/30 leaf-bg">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 fade-in">
          <p className="text-xs uppercase tracking-[0.3em] text-brand-accent font-semibold" style={{ color: "var(--brand-500)" }}>What we trade</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-brand mt-2">Our Commodity Categories</h2>
          <p className="mt-4 text-muted-foreground">
            We provide a wide range of high-quality industrial raw materials, finished products and related items. Through careful sourcing and processing, our products meet the highest industry standards and cater to various markets globally.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {visible.map((c) => (
            <Link
              key={c.slug}
              to={`/products/${c.slug}`}
              className="group card-hover relative overflow-hidden rounded-xl bg-white border border-border fade-in"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-90" />
              <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-white/15 backdrop-blur-md text-white text-[11px] font-semibold uppercase tracking-wider border border-white/25">
                Category {c.code}
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="font-display text-white font-bold text-xl mb-1">{c.title}</h3>
                <p className="text-white/80 text-sm line-clamp-2">{c.short}</p>
                <span className="inline-flex items-center gap-1.5 text-white text-sm font-semibold mt-3 group-hover:gap-3 transition-all">
                  Explore <ArrowRight size={15} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
